export default "__VITE_ASSET__f4666770__"